import { useState, useEffect } from "react";

const GA_ID = "G-E7922BTW3M";      // Google Analytics 4
const ADS_ID = "AW-970875118";     // Google Ads (conversiones)
const CLARITY_ID = "tmi7f8iz04";   // Microsoft Clarity (grabación de sesiones)

// Carga toda la analítica. Idempotente: puede llamarse desde el consentimiento
// inicial y desde el arranque de visitas posteriores sin duplicar scripts.
// Ads y Clarity estaban en public/index.html cargándose sin consentimiento;
// se movieron aquí para que todo el seguimiento siga el mismo criterio.
function cargarAnalytics() {
  if (window.__analyticsCargado) return;
  window.__analyticsCargado = true;

  // Un solo gtag.js sirve para GA4 y para Ads: se configuran por separado.
  const script1 = document.createElement("script");
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script1.async = true;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag("js", new Date());
    gtag("config", "${GA_ID}", { anonymize_ip: true });
    gtag("config", "${ADS_ID}");
  `;
  document.head.appendChild(script2);

  const clarity = document.createElement("script");
  clarity.innerHTML = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${CLARITY_ID}");
  `;
  document.head.appendChild(clarity);
}

export default function CookiesBanner() {
  const [showCookiesBanner, setShowCookiesBanner] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (accepted === "true") {
      // Sin esto, Analytics solo se cargaba en la sesión en la que se pulsaba
      // "Aceptar": todas las visitas posteriores quedaban sin medir.
      cargarAnalytics();
    } else if (accepted !== "false") {
      setShowCookiesBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setShowCookiesBanner(false);
    cargarAnalytics();
  };

  const handleReject = () => {
    localStorage.setItem("cookiesAccepted", "false");
    setShowCookiesBanner(false);

    const scripts = document.querySelectorAll(
      'script[src*="googletagmanager.com"], script[src*="google-analytics.com"], script[src*="clarity.ms"]'
    );
    scripts.forEach((script) => script.remove());
    window[`ga-disable-${GA_ID}`] = true;
    window.__analyticsCargado = false;
    window.dataLayer = [];
    window.gtag = undefined;
    window.clarity = undefined;
  };

  if (!showCookiesBanner) return null;

  return (
    <div className="cookies-banner" style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      background: "#f8f9fa",
      padding: "1rem",
      borderTop: "1px solid #ccc",
      boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "0.8rem",
      fontSize: "0.95rem"
    }}>
      <p style={{ margin: 0 }}>
        Usamos cookies propias y de terceros para analizar el uso del sitio y mejorar tu experiencia.{" "}
        <a href="/politica-cookies" target="_blank" rel="noopener noreferrer">Más info</a>
      </p>
      <div style={{ display: "flex", gap: "10px" }}>
        <button onClick={handleReject} className="cookie-button reject" style={{
          padding: "0.4rem 1rem",
          border: "1px solid #ccc",
          borderRadius: "4px",
          background: "#fff",
          cursor: "pointer"
        }}>Rechazar</button>
        <button onClick={handleAccept} className="cookie-button accept" style={{
          padding: "0.4rem 1rem",
          border: "none",
          borderRadius: "4px",
          background: "#235470",
          color: "#fff",
          cursor: "pointer"
        }}>Aceptar</button>
      </div>
    </div>
  );
}
